import AjaxBuilder from "../../../../Common/AjaxBuilder";
import { Loader } from "../../../CommonComponents/Insurance/Loader";

export class Country {
    constructor({ insuranceForm, currency, state }) {
        this.$insuranceForm = insuranceForm;
        this._state = state;

        this.$countrySelect = $(this.$insuranceForm).find('#countrySelect');

        this._route = this.$insuranceForm.data('countries');

        this._selectize = null;
        this._countries = null;
        this._selectedCountry = null;

        this._currency = currency;

        this._init();
    }

    _init() {
        this._selectize = $(this.$countrySelect).selectize({
            onItemAdd: this._selectCountry.bind(this),
        });

        this._getCountriesFromApi();
    }
    
    _getCountriesFromApi() {
        Loader.showLoader(this.$form);
        
        new AjaxBuilder({
            route: this._route,
        }, 'GET').execute({
            success: this._getCountriesSuccess.bind(this),
            error: this._getCountriesError.bind(this),
        })
    }

    _getCountriesSuccess(data) {
        this._countries = this._prepareCountriesData(data.response);
        this._selectize[0].selectize.addOption(this._countries);
        this._selectize[0].selectize.addItem('1');
        Loader.hideLoader(this.$form);
    }

    _getCountriesError(data) {
        Loader.hideLoader(this.$form);
    }

    _prepareCountriesData(countries) {
        const contriesResult = [];

        countries.forEach(country => {
            if (
                (this._lang === 'uk-ua' && country.country_name_uk === '') 
                || (this._lang !== 'uk-ua' && country.country_name_ru === '')
                ||  country.country_name_ru === 'Россия'
                ||  country.country_name_ru === 'Белорусь'
            ) {
                return;
            }

            contriesResult.push({
                value: country.id,
                text: this._lang === 'uk-ua' ? country.country_name_uk : country.country_name_ru,
                is_group: !!Number(country.is_group),
            })
        });

        return contriesResult;

        // return countries.map(country => {
        //     return {
        //         value: country.id,
        //         text: this._lang === 'uk-ua' ? country.country_name_uk : country.country_name_ru,
        //         is_group: !!Number(country.is_group),
        //     };
        // })
    }

    _selectCountry(value) {
        this._selectedCountry = this._countries.find(country => country.value === +value);
        this._currency.hideCurrencySelection();
        this._state.country = this._selectedCountry;
        if (this._selectedCountry.is_group) this._currency.showCurrencySelection();        
    }
}